<template>
	<div id="buildingEnter">
        <div class="fixedIconBox" @click="toForm">
            <span class="titleText">使用软件</span>
        </div>
		<img src="../../images/internetPlat/plat_02.jpg" alt="" @click="toForm"/>
		<img src="../../images/internetPlat/plat_03.jpg" alt="" />
		<div class="longBtnBox" style="margin-bottom: 1rem;">
			<button class="btn-red btn-long btn-shadow" @click="toForm">申请使用订货会系统</button>
		</div>
		<img src="../../images/internetPlat/plat_04.jpg" alt="" />
		<img src="../../images/internetPlat/plat_06.jpg" alt="" />
		
	</div>
</template>

<script>
    import {        setCookie,        phoneReg,        codeReg,        filterPhoneNum,        GetRequest    } from '@/assets/common.js'

	export default {
		data() {
			return {
                isFromYjj:'',
                paramObj:'',
                code:'',

			}
		},
		methods: {
			toForm(){
				this.$router.push({name:'InternetForm'});
			}
		},
		mounted() {
            //判断是否返回即可，不需要重新登录
            this.paramObj = GetRequest()
            console.log(this.paramObj )
            this.code = this.paramObj.c
            this.isFromYjj=this.code?true:false
        }
	}
</script>

<style lang="less" scoped="scoped">
img{width: 100%;}

</style>


// WEBPACK FOOTER //
// src/page/introPage/internet.vue